<div class="dashboard">
  <div class="header">
    <h1>Добро пожаловать</h1>
    <p>Отслеживайте, управляйте поддержкой для своих клиентов.</p>
  </div>
  <div class="stats">
    <div class="stats-item">
      <div class="text-column">
        <p class="title">Кол-во звонков</p>
        <p class="number">{{ totalCalls }}</p>
      </div>
      <img :src="require('@/assets/phone.svg')" alt="Phone Icon" />
    </div>
    <div class="stats-item">
      <div class="text-column">
        <p class="title">Кол-во минут</p>
        <p class="number">{{ totalMinutes }}</p>
      </div>
      <img :src="require('@/assets/time.svg')" alt="Phone Icon" />
    </div>
    <div class="stats-item">
      <div class="text-column">
        <p class="title">Общая стоимость</p>
        <p class="number">{{ totalCost }} $</p>
      </div>
      <img :src="require('@/assets/cost.svg')" alt="Phone Icon" />
    </div>
  </div>

  <div class="selector">
    <label for="month">Select Month:</label>
    <input type="month" v-model="selectedMonth" @change="fetchStatistics" />
  </div>

  <div id="chart"></div>
  <!-- <div class="batch-settings">
    <h3>Batch Settings</h3>
    <div class="batch-field">
      <label>Flow:</label>
      <input type="text" v-model="flow" placeholder="Enter flow" />
    </div>
    <div class="batch-field">
      <label>Start Time:</label>
      <input type="datetime-local" v-model="startTimeBatch" />
    </div>
    <div class="batch-field">
      <label>End Time:</label>
      <input type="datetime-local" v-model="endTimeBatch" />
    </div>
    <div class="batch-field">
      <label>Workers:</label>
      <input type="number" v-model.number="numberOfConnections" min="1" />
    </div>
    <div class="batch-field">
      <label>Retry Count:</label>
      <input type="number" v-model.number="retryCount" min="0" />
    </div>
    <div class="batch-field">
      <label>Retry Interval (minutes):</label>
      <input type="number" v-model.number="retryInterval" min="0" />
    </div>
  </div> -->
  <div class="upload-container">
    <div class="upload-box">
      <h3>Загрузите Excel файл</h3>
      <label class="custom-file-upload">
        <input
          ref="fileInput"
          type="file"
          @change="onFileChange"
          accept=".xlsx,.xls"
        />
        Выбрать Файл
      </label>
      <div v-if="fileName" class="file-info">
        <span>{{ fileName }}</span>
        <button @click="resetFile" class="reset-file-button">X</button>
      </div>
    </div>
    <div class="status-container">
      <!-- <button
        @click="handleFileUpload"
        :class="isButtonEnabled ? 'button-ready' : 'button-disabled'"
        :disabled="!isButtonEnabled || isLoading"
      > -->
       <button
        @click="handleFileUpload"
        :class="'button-ready'"
      >
        <span v-if="!isLoading">Начать обзвон</span>
        <div v-else class="spinner"></div>
      </button>
    </div>
  </div>
</div>
